
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/news/[id]",
      function () {
        return require("private-next-pages/destinations/news/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/news/[id]"])
      });
    }
  